import React from "react";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/material/styles";
import Dashboard from "@mui/icons-material/Dashboard";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import People from "@mui/icons-material/People";
import GroupAdd from "@mui/icons-material/GroupAdd";
import grey from "@mui/material/colors/grey";
import Add from "@mui/icons-material/Add";
import Edit from "@mui/icons-material/Edit";
import CalendarToday from "@mui/icons-material/CalendarToday";
import EventIcon from "@mui/icons-material/Event";
import Assignment from "@mui/icons-material/Assignment";
import SchoolIcon from "@mui/icons-material/School";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import Work from "@mui/icons-material/Work";
import PermContactCalendar from "@mui/icons-material/PermContactCalendar";
import { useFirestoreConnect } from "react-redux-firebase";
import { useSelector, useDispatch } from "react-redux";
import { Divider, ListItemIcon, Grid } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import classNames from "classnames";
import { TOGGLE_SEMESTER_DIALOG } from "../../constants";
import useMediaQuery from "@mui/material/useMediaQuery";

const PREFIX = "NavButtons";

const classes = {
  button: `${PREFIX}-button`,
  activeButton: `${PREFIX}-activeButton`,
  label: `${PREFIX}-label`,
  icon: `${PREFIX}-icon`,
  studentMenu: `${PREFIX}-studentMenu`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled("div")(({ theme }) => ({
  [`& .${classes.button}`]: {
    height: 60, // setting height/width is optional
    color: grey[500],
    flexDirection: "column",
    fontWeight: "700",
    fontSize: "0.7em",
  },

  [`& .${classes.activeButton}`]: {
    color: theme.palette.primary.main,
  },

  [`& .${classes.label}`]: {
    // Aligns the content of the button vertically.
    flexDirection: "column",
  },

  [`& .${classes.icon}`]: {
    [theme.breakpoints.up("xl")]: {
      fontSize: "1.2rem !important",
    },
    [theme.breakpoints.down("xl")]: {
      fontSize: "1.2rem !important",
    },
    marginBottom: theme.spacing(),
  },

  [`& .${classes.studentMenu}`]: {
    maxHeight: 350,
    overflow: "hidden",
  },
}));

function StudentsMenu({ matches, current }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const dispatch = useDispatch();

  const history = useHistory();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useFirestoreConnect(["semesters"]);
  const semesters = useSelector(
    (state) => state.firestore.ordered.semesters || []
  );

  return (
    <div>
      <Button
        variant="text"
        classes={{ root: classes.button, label: classes.label }}
        className={classNames({
          [classes.activeButton]: current,
        })}
        onClick={handleClick}
      >
        <People className={classes.icon} />
        {matches ? "Studerende" : ""}
      </Button>

      <Menu
        anchorEl={anchorEl}
        className={classes.studentMenu}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {semesters
          .slice()
          .sort()
          .reverse()

          .map((semester) => {
            return (
              <MenuItem
                key={semester.id}
                onClick={() => {
                  handleClose();
                  history.push(`/semesters/${semester.id}`);
                }}
              >
                <ListItemIcon>
                  <CalendarToday fontSize="small" />
                </ListItemIcon>
                {semester.title}
              </MenuItem>
            );
          })}
        <Divider />
        <MenuItem
          onClick={() => {
            handleClose();
            dispatch({ type: TOGGLE_SEMESTER_DIALOG, semesterOpen: true });
          }}
        >
          <ListItemIcon>
            <Add fontSize="small" />
          </ListItemIcon>
          Tilføj semester
        </MenuItem>
        <MenuItem onClick={() => history.push("/exams")}>
          <ListItemIcon>
            <Add fontSize="small" />
          </ListItemIcon>
          Tilføj Eksamensresultater
        </MenuItem>
      </Menu>
    </div>
  );
}

function ExamsMenu({ matches, current }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const history = useHistory();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        variant="text"
        classes={{ root: classes.button, label: classes.label }}
        className={classNames({
          [classes.activeButton]: current,
        })}
        onClick={handleClick}
      >
        <SchoolIcon className={classes.icon} />
        {matches ? "Eksamensresultater" : ""}
      </Button>

      <Menu
        anchorEl={anchorEl}
        className={classes.studentMenu}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            history.push(`/exams`);
          }}
        >
          <ListItemIcon>
            <Assignment fontSize="small" />
          </ListItemIcon>
          Tildel
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            history.push(`/exams/edit`);
          }}
        >
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          Rediger
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            history.push(`/exams/add`);
          }}
        >
          <ListItemIcon>
            <Add fontSize="small" />
          </ListItemIcon>
          Tilføj
        </MenuItem>
      </Menu>
    </div>
  );
}

export const NavButtons = () => {
  const history = useHistory();
  const location = useLocation();

  const current = (path) => {
    const topLevelPath = path.split("/");
    const current = location.pathname.split("/");
    return current[1] === topLevelPath[1];
  };
  const matches = useMediaQuery("(min-width:1280px)");

  return (
    <Root>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item>
          <Button
            variant="text"
            onClick={() => history.push("/")}
            classes={{ root: classes.button, label: classes.label }}
            className={classNames({
              [classes.activeButton]: current("/"),
            })}
          >
            <Dashboard className={classes.icon} />
            {matches ? "Dashboard" : ""}
          </Button>
        </Grid>
        <Grid item>
          <Button
            onClick={() => history.push("/applicants")}
            className={classNames({
              [classes.activeButton]: current("/applicants"),
            })}
            variant="text"
            classes={{ root: classes.button, label: classes.label }}
          >
            <GroupAdd className={classes.icon} />
            {matches ? "Ansøgere" : ""}
          </Button>
        </Grid>
        <Grid item>
          <Button
            onClick={() => history.push("/events")}
            className={classNames({
              [classes.activeButton]: current("/events"),
            })}
            variant="text"
            classes={{ root: classes.button, label: classes.label }}
          >
            <EventIcon className={classes.icon} />
            {matches ? "Infoaftener" : ""}
          </Button>
        </Grid>
        <Grid item>
          <StudentsMenu matches={matches} current={current("/semesters")} />
        </Grid>
        <Grid item>
          <Button
            variant="text"
            onClick={() => history.push("/examiners")}
            classes={{ root: classes.button, label: classes.label }}
            className={classNames({
              [classes.activeButton]: current("/examiners"),
            })}
          >
            <Assignment className={classes.icon} />
            {matches ? "Censorer" : ""}
          </Button>
        </Grid>
        <Grid item>
          <Button
            onClick={() => history.push("/employees")}
            className={classNames({
              [classes.activeButton]: current("/employees"),
            })}
            variant="text"
            classes={{ root: classes.button, label: classes.label }}
          >
            <Work className={classes.icon} />
            {matches ? "Ansatte" : ""}
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="text"
            onClick={() => history.push("/contacts")}
            classes={{ root: classes.button, label: classes.label }}
            className={classNames({
              [classes.activeButton]: current("/contacts"),
            })}
          >
            <PermContactCalendar className={classes.icon} />
            {matches ? "Kontakter" : ""}
          </Button>
        </Grid>
        <Grid item>
          <Button
            onClick={() => history.push("/subjects")}
            className={classNames({
              [classes.activeButton]: current("/subjects"),
            })}
            variant="text"
            classes={{ root: classes.button, label: classes.label }}
          >
            <MenuBookIcon className={classes.icon} />
            {matches ? "Fag" : ""}
          </Button>
        </Grid>
        {/* <Grid item>
          <ExamsMenu matches={matches} current={current("/exams")} />
        </Grid> */}
      </Grid>
    </Root>
  );
};

export default NavButtons;
